module.exports = __webpack_public_path__ + "img/解决方案_定制_灰.86349172.svg";